import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AuthService } from '../../auth/auth.service';
import { AuthDataInterface } from '../../auth/auth';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

import { USERS_PATHS } from '../../users/users';
import { SECTORS_PATHS } from '../../sectors/sectors';
import { WORK_SHIFT_PATHS } from '../../work-shift/work-shift';
import { NOTIFICATIONS_PATHS } from '../../notifications/notifications';
import { WORK_SHIFTS_PATHS } from '../../work-shifts/work-shifts';
import { COMPANIES_PATHS } from '../../companies/companies';
import { NORMATIVES_PATHS } from '../../normatives/normatives';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss'],
  standalone: false,
})
export class ReferencesComponent implements OnInit {
  public USERS_PATHS = USERS_PATHS;
  public SECTORS_PATHS = SECTORS_PATHS;
  public WORK_SHIFT_PATHS = WORK_SHIFT_PATHS;
  public NOTIFICATIONS_PATHS = NOTIFICATIONS_PATHS;
  public WORK_SHIFTS_PATHS = WORK_SHIFTS_PATHS;
  public COMPANIES_PATHS = COMPANIES_PATHS;
  public NORMATIVES_PATHS = NORMATIVES_PATHS;
  public referencesBreadcrumbs: Breadcrumb[] = [{ text: 'Справочники', url: null }];
  public authData: AuthDataInterface;

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.referencesBreadcrumbs);
    this.authService.subscribeAuthData().subscribe((authData) => {
      this.authData = authData;
    });
  }
}
